import { FC, PropsWithChildren, StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router";

import App from "./app/App";
import translations from "./app/i18n/locales";
import { getLocaleStringFromBrowserSetting } from "./app/utils/detectLanguage";

import "./styles.css";

// In future this would be set by a control on the page
// if you want to test Netherlands or English just change this to nl or en
// if you want to test traditional Chinese then change to zh-TW
const localeProp = getLocaleStringFromBrowserSetting();

// Note that this is also used elsewhere
export const WithIntl: FC<PropsWithChildren> = ({ children }) => (
  <IntlProvider
    locale={localeProp}
    defaultLocale="en"
    key={localeProp}
    messages={
      translations[
        // locale for traditional Chinese is zh-TW, but since
        // zh-TW is not a valid name to be exported from locales.js
        // we use zh_TW instead for traditional Chinese
        localeProp === "zh-TW" ? "zh_TW" : localeProp
      ]
    }
  >
    {children}
  </IntlProvider>
);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <StrictMode>
    <BrowserRouter>
      <WithIntl>
        <App />
      </WithIntl>
    </BrowserRouter>
  </StrictMode>
);
